import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentRepoService {

  private readonly GET_INSIDE_ENG_DOC_REPO = environment.apiV1 + '/inside-eng-doc-repo';

  constructor(private http: HttpClient, private toaster: ToastrService) {
  }

  public getInsideEngDocRepo(clientUserAccountId, orderType, searchTxt, clientFirmId): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(this.GET_INSIDE_ENG_DOC_REPO,
      {params: {clientUserAccountId: clientUserAccountId, orderType: orderType, searchTxt: searchTxt, clientFirmId: clientFirmId}})
  }
}
